import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { initSentry, SentryErrorBoundary } from "./lib/sentry.js";
import { initConsentMode } from "./lib/consent-mode/index.js";
import { initAttribution, initAttributionBeacon } from "./lib/attribution/index.js";
import App from "./App.jsx";
import i18n from "./locales/i18n.js";
import "./index.css";

initSentry();

// Tell Google what the visitor has already agreed to, and keep it in step with
// every later change. index.html has already declared the deny-by-default state
// inline (it has to run before GTM); this is the earliest a bundled module can
// upgrade that for a returning visitor. Before React renders, so an accepted
// visitor is not measured cookielessly while the app boots.
initConsentMode();

// Read the campaign parameters off the URL before React renders — the first
// client-side navigation replaces the query string, and with it the only
// record of which ad brought this visitor. Nothing is stored unless marketing
// consent allows it; until then the touch is held in memory and flushed if the
// visitor accepts.
initAttribution();

// Hand whatever was captured to the server, which then owns it — at most one
// request per campaign touch, never on an ordinary page view, and never without
// marketing consent. A successful handoff deletes the browser's staging copy, so
// from that moment the authoritative record is the server's alone.
initAttributionBeacon({ apiUrl: import.meta.env.VITE_API_URL });

ReactDOM.createRoot(document.getElementById("root")).render(
  <SentryErrorBoundary
    fallback={
      <div style={{ padding: "2rem", textAlign: "center" }}>
        {i18n.t("common.errorBoundaryFallback")}
      </div>
    }
  >
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </SentryErrorBoundary>,
);
